import React, { useState, useEffect } from 'react';
import './styles/Examination.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Eye from './components/Eye/eye';
import { getAuthUrl } from './config/api';
import { useUser } from './contexts/UserContext';

const WRONG_CODE_MESSAGE = 'Неверный код';

function isTokenValid(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

const Auth = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // После верного пароля бэкенд шлёт код на почту и отдаёт challenge_id для его проверки
  const [challengeId, setChallengeId] = useState('');
  const [maskedEmail, setMaskedEmail] = useState('');
  const [code, setCode] = useState('');
  const navigate = useNavigate();
  const { fetchUserProfile } = useUser();

  useEffect(() => {
    const saved = localStorage.getItem('savedUsername');
    if (saved) {
      setUsername(saved);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('savedUsername', username);
  }, [username]);

  useEffect(() => {
    const access = localStorage.getItem('access');
    if (access && isTokenValid(access)) {
      navigate('/');
    }
  }, [navigate]);

  const loginWithTokens = async (data: { access: string; refresh: string }) => {
    localStorage.setItem('access', data.access);
    localStorage.setItem('refresh', data.refresh);
    try {
      await fetchUserProfile();
    } catch {
    }
    navigate('/');
  };

  const getErrorMessage = (err: unknown, fallback: string): string => {
    if (axios.isAxiosError(err)) {
      if (err.response?.status === 429) {
        return 'Слишком много попыток, подождите минуту';
      }
      const detail = err.response?.data?.detail;
      if (typeof detail === 'string' && err.response?.status !== 401) {
        return detail;
      }
    }
    return fallback;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(getAuthUrl('TOKEN'), {
        username: username,
        password: password,
      });
      if (response.data?.two_factor_required) {
        setChallengeId(response.data.challenge_id);
        setMaskedEmail(response.data.email || '');
        setCode('');
      } else if (response.data && response.data.access) {
        await loginWithTokens(response.data);
      } else {
        setError('Неверный логин или пароль');
      }
    } catch (err) {
      setError(getErrorMessage(err, 'Неверный логин или пароль'));
    }
  };

  const handleCodeSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post(getAuthUrl('VERIFY_CODE'), {
        challenge_id: challengeId,
        code: code.trim(),
      });
      await loginWithTokens(response.data);
    } catch (err) {
      const message = getErrorMessage(err, WRONG_CODE_MESSAGE);
      // Код просрочен или попытки кончились — возвращаем на ввод пароля
      if (message !== WRONG_CODE_MESSAGE && axios.isAxiosError(err) && err.response?.status === 400) {
        setChallengeId('');
        setPassword('');
      }
      setError(message);
    }
  };

  const backToPassword = () => {
    setChallengeId('');
    setCode('');
    setPassword('');
    setError('');
  };

  return (
    <div className="org-form__container">
      <Eye />
      <div className="org-form__title">Вход в систему</div>
      {challengeId ? (
      <form onSubmit={handleCodeSubmit} style={{width: '100%',marginTop: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <div style={{ marginBottom: 10, textAlign: 'center' }}>
          Код подтверждения отправлен на {maskedEmail || 'вашу почту'}
        </div>
        <input
          type="text"
          name="code"
          placeholder="Код из письма"
          className="org-form__input"
          value={code}
          onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          inputMode="numeric"
          autoComplete="one-time-code"
          autoFocus
        />
        {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
        <button type="submit" className="org-form__button org-form__button--search" disabled={code.length !== 6}>
          Подтвердить
        </button>
        <button type="button" className="org-form__button org-form__button--back" onClick={backToPassword}>
          Назад
        </button>
      </form>
      ) : (
      <form onSubmit={handleSubmit} style={{width: '100%',marginTop: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <input
          type="text"
          name="username"
          placeholder="Логин"
          className="org-form__input"
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoComplete="username"
        />
        <input
          type="password"
          placeholder="Пароль"
          className="org-form__input"
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="current-password"
        />
        {error && <div style={{ color: 'red', marginBottom: 10 }}>{error}</div>}
        <button type="submit" className="org-form__button org-form__button--search">
          Войти
        </button>
      </form>
      )}
    </div>
  );
};

export default Auth;
